import React, { useEffect, useRef, useState } from "react"
import SoftButton from "./SoftButton"
import { CaretUp, CaretDown, CaretRight, CaretLeft } from "@phosphor-icons/react"
import { Link } from "gatsby";

const SoftDropdownButton = ({
  label,
  menu = [],
  disableDefaultDropdown = false,
  className = "",
  onClick = null,
  openOnHover = false,
  openChildOnHover = false,
  iconGap = "gap-x-3",
  isOpenRef = null,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [subMenuOpen, setSubMenuOpen] = useState(false)
  const menuRef = useRef(null)

  useEffect(() => {
    // const handleClickOutside = (event) => {
    //   if (menuRef.current && !menuRef.current.contains(event.target)) {
    //     setDropdownOpen(false)
    //   }
    // }

    // document.addEventListener("mousedown", handleClickOutside, {passive: true})
    // return () => {
    //   document.removeEventListener("mousedown", handleClickOutside, {passive: true})
    // }
  }, [])

  useEffect(() => {
    if (!dropdownOpen) setSubMenuOpen(false);
  }, [dropdownOpen]);

  useEffect(() => {
    if(onClick) {
      onClick(dropdownOpen)
    }
  }, [dropdownOpen])

  useEffect(() => {
    if(!isOpenRef) {
      setDropdownOpen(false)
    }
  }, [isOpenRef])


  return (
    <div ref={menuRef} className="relative inline-block w-full text-left">
      <div
        className={"flex"}
        onMouseEnter={(e) => {
          if (openOnHover) {
            setDropdownOpen(true)
          }
        }}
        onMouseLeave={() => {}}
      >
        <SoftButton
          label={label}
          iconGap={iconGap}
          onClick={(e) => {
            // if (openOnHover && !dropdownOpen) return;
            if (onClick) onClick(e);
            setDropdownOpen(!dropdownOpen);
          }}
          icon={
            dropdownOpen ? (
              <CaretUp size={20} weight="light" />
            ) : (
              <CaretDown size={20} weight="light" />
            )
          }
          className={className}
          ariaLabel={label}
        />
      </div>

      {dropdownOpen && !disableDefaultDropdown && (
        <div 
          className="bg-black mt-0.5 origin-top-right absolute right-0 w-[280px] shadow-lg text-white z-50"
          onMouseLeave={() => {
            if (openOnHover) setDropdownOpen(false)
          }}
        >
          <div
            className="py-5"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            {menu &&
              menu?.map((item, index) => {
                if (item?.subMenus?.length > 0) {
                  return (
                    <div className={`relative group ${openChildOnHover && 'group-hover:block group-hover:scale-100'}`} key={`menu-${index}${item.label}`}>
                      <button
                        type="button"
                        className="header-menu-item w-full after-border-bottom-0-dotted hover:after:!border-0 focus:outline-none peer"
                        onClick={() => setSubMenuOpen(!subMenuOpen)}
                      >
                        <span className="ml-2">{item.label}</span>
                        <CaretRight size={20} weight="light" />
                      </button>
                      <div
                        className={`absolute origin-top-right right-full -top-4 w-[280px] shadow-lg bg-black py-3 ${openChildOnHover && 'hidden scale-95 group-hover:block group-hover:scale-100'}`}
                      >
                        <div
                          className="py-1"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="submenu"
                        >
                          <div className="flex gap-x-3 items-center py-2 after-border-bottom-0-dotted text-xs px-4">
                            {/* <CaretLeft size={20} weight="light" /> */}
                            <span className="ml-2">{item.label}</span>
                          </div>
                          {item?.subMenus?.map((subMenu, subIndex) => {
                            return (
                              subMenu?.link ? (
                                <Link
                                  to={subMenu?.link ?? "/"}
                                  className={`flex px-4 py-3 text-xs text-white hover:bg-white hover:text-black ${
                                    subIndex + 1 === item?.subMenus?.length
                                      ? ""
                                      : "after-border-bottom-0-dotted hover:after:!border-0"
                                  }`}
                                  role="menuitem"
                                  key={`sub-menu-${subIndex}`}
                                >
                                  <span className="ml-2">{subMenu.label}</span>
                                </Link>
                              ) : (
                                <a href={subMenu?.url ?? "#"} target="_blank"
                                  className={`flex px-4 py-3 text-xs text-white hover:bg-white hover:text-black ${
                                    subIndex + 1 === item?.subMenus?.length
                                      ? ""
                                      : "after-border-bottom-0-dotted hover:after:!border-0"
                                  }`}
                                  role="menuitem"
                                  key={`sub-menu-${subIndex}`}
                                  aria-label={subMenu?.label}
                                >
                                  <span className="ml-2">{subMenu?.label}</span> 
                                </a> 
                              )
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div
                      className={`header-menu-item ${
                        index + 1 === menu?.length
                          ? ""
                          : "after-border-bottom-0-dotted hover:after:!border-0"
                      }`}
                      role="menuitem"
                      key={`menu-${index}`}
                    >
                      <span className="ml-2">{item.label}</span>
                      {/* <CaretRight size={20} weight="light" /> */}
                    </div>

                    // <Link
                    //   to="/"
                    //   className={`header-menu-item ${
                    //     index + 1 === menu?.length
                    //       ? ""
                    //       : "after-border-bottom-0-dotted hover:after:!border-0"
                    //   }`}
                    //   role="menuitem"
                    //   key={`menu-${index}`}
                    // >
                    //   <span className="ml-2">{item.label}</span>
                    //   {/* <CaretRight size={20} weight="light" /> */}
                    // </Link>
                  );
                }
              })}
          </div>
        </div>
      )}
    </div>
  );
};

export default SoftDropdownButton;
